'use es6';

import { debounce } from 'underscore';
import { CODEMIRROR_SESSION_EDITOR_REMOVE, CODEMIRROR_SESSION_EDITOR_UPDATE } from 'DesignData/actions/ActionTypes';
import { save } from 'DesignData/actions/codemirror/Session';
const saveSession = debounce(dispatch => {
  dispatch(save());
}, 500);
export default (({
  dispatch
}) => next => action => {
  const result = next(action);

  switch (result.type) {
    case CODEMIRROR_SESSION_EDITOR_REMOVE:
    case CODEMIRROR_SESSION_EDITOR_UPDATE:
      {
        saveSession(dispatch);
        break;
      }

    default:
      break;
  }

  return result;
});